import * as yup from 'yup';
import { OwnerModelDTO } from '../../StockOptions.meta';

export interface FormValues {
  name: string;
  owner: string;
  assetClass: number;
  earmarks: { label: string; value: string }[];
  ownerModel: OwnerModelDTO[];
}

export const validation = yup.object().shape({
  name: yup
    .string()
    .nullable()
    .required('Please specify a Company Name.'),
  owner: yup
    .string()
    .nullable()
    .required('Please specify an owner for this account.'),
});
